export const TIMER_MODAL_TIMER_TAB_ID = 1

export const TIMER_MODAL_TABS = [
  {
    id: TIMER_MODAL_TIMER_TAB_ID,
    title: 'Timer',
    defaultTab: true
  },
  {
    id: 2,
    title: 'Manual'
  }
]



// WEBPACK FOOTER //
// ./src/constants/Tabs/timerModalTabs.js